export interface MainTableUser {
  id: number;
  email?: string;
  username?: string;
  DisplayName?: string;
  PersonalNumber?: string;
}

export interface MainTableCard {
  id: number;
  title?: string | null;
  dateAudit: string | null;
  plannedDate: string | null;
  isAudit: boolean;
  monthIdx: number;
  typeAudit: string | null;
  zone: string | null;
  areaId: number | null;
  departmentId: number | null;
  locationId: number | null;
  templateId: number | null;
  locationName?: string | null;
  departmentName?: string | null;
  areaName?: string | null;
  auditor: MainTableUser | null;
  coAuditor: MainTableUser | null;
  percent: number;
  sectionPercents?: Record<string, number>;
  isMissedPlan?: boolean;
}

export interface MainTableMonthsConfigItem {
  name: string;
  count: number;
}

export interface MainTableData {
  cards: MainTableCard[];
  monthsConfig: MainTableMonthsConfigItem[];
  filters?: Record<string, any>;
}

export interface MainTable5SState {
  table: {
    data: MainTableData | null;
    loading: boolean;
    error: string | null;
  };
  editCard: {
    data: any | null;
    loading: boolean;
    error: string | null;
  };
  deleteCard: {
    loading: boolean;
    error: string | null;
    lastDeletedId: number | null;
  };
}

export enum MainTable5SActionTypes {
  LOAD_TABLE_REQUEST = 'mainTable5S/LOAD_TABLE_REQUEST',
  LOAD_TABLE_SUCCESS = 'mainTable5S/LOAD_TABLE_SUCCESS',
  LOAD_TABLE_FAILURE = 'mainTable5S/LOAD_TABLE_FAILURE',

  LOAD_EDIT_CARD_REQUEST = 'mainTable5S/LOAD_EDIT_CARD_REQUEST',
  LOAD_EDIT_CARD_SUCCESS = 'mainTable5S/LOAD_EDIT_CARD_SUCCESS',
  LOAD_EDIT_CARD_FAILURE = 'mainTable5S/LOAD_EDIT_CARD_FAILURE',
  CLEAR_EDIT_CARD = 'mainTable5S/CLEAR_EDIT_CARD',

  DELETE_CARD_REQUEST = 'mainTable5S/DELETE_CARD_REQUEST',
  DELETE_CARD_SUCCESS = 'mainTable5S/DELETE_CARD_SUCCESS',
  DELETE_CARD_FAILURE = 'mainTable5S/DELETE_CARD_FAILURE',
}

export interface LoadTableRequestAction {
  type: MainTable5SActionTypes.LOAD_TABLE_REQUEST;
  payload: { params: Record<string, any> };
}

export interface LoadTableSuccessAction {
  type: MainTable5SActionTypes.LOAD_TABLE_SUCCESS;
  payload: { data: MainTableData };
}

export interface LoadTableFailureAction {
  type: MainTable5SActionTypes.LOAD_TABLE_FAILURE;
  payload: { error: string };
}

export interface LoadEditCardRequestAction {
  type: MainTable5SActionTypes.LOAD_EDIT_CARD_REQUEST;
  payload: { id: number };
}

export interface LoadEditCardSuccessAction {
  type: MainTable5SActionTypes.LOAD_EDIT_CARD_SUCCESS;
  payload: { data: any };
}

export interface LoadEditCardFailureAction {
  type: MainTable5SActionTypes.LOAD_EDIT_CARD_FAILURE;
  payload: { error: string };
}

export interface ClearEditCardAction {
  type: MainTable5SActionTypes.CLEAR_EDIT_CARD;
}

export interface DeleteCardRequestAction {
  type: MainTable5SActionTypes.DELETE_CARD_REQUEST;
  payload: { id: number };
}

export interface DeleteCardSuccessAction {
  type: MainTable5SActionTypes.DELETE_CARD_SUCCESS;
  payload: { id: number };
}

export interface DeleteCardFailureAction {
  type: MainTable5SActionTypes.DELETE_CARD_FAILURE;
  payload: { error: string };
}

export type MainTable5SActions =
  | LoadTableRequestAction
  | LoadTableSuccessAction
  | LoadTableFailureAction
  | LoadEditCardRequestAction
  | LoadEditCardSuccessAction
  | LoadEditCardFailureAction
  | ClearEditCardAction
  | DeleteCardRequestAction
  | DeleteCardSuccessAction
  | DeleteCardFailureAction;
